import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { StudentTeamAttendance } from '../../../shared-components/student/attendance.model';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { SharedService } from '../../../shared-components/shared.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { UserService } from '../../../shared-components/user/user.service';
import { Router } from '@angular/router';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';


@Component({
  selector: 'by-team-table',
  templateUrl: './by-team-table.component.html',
  animations: [detailExpand]
})
export class ByTeamTableComponent implements OnInit {

  // ----------Angular Material------------------------------------
  angularMatData = new TylerMatTableDataSource();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  columnsToDisplayTeamAttendance: string[] = ['More', 'stName', 'staffName', 'aCount', 'tCount'];
  @Input() teamAttendance: StudentTeamAttendance[];

  constructor(
    private sharedService: SharedService,
    private studentService: StudentService,
    private userService: UserService,
    private router: Router) {
}

  ngOnInit() {
    this.angularMatData.data = this.teamAttendance;
    this.angularMatData.sort = this.sort;
  }

      // ----------Angular Material------------------------------------
      toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.sharedService.updateShowSpinner(true);
        setTimeout(() => {
            this.angularMatData.expandAll(expand);
            this.sharedService.updateShowSpinner(false);
        }, 100);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);

    }

    getAriaRowByTeamAttendance(row: StudentTeamAttendance): string {
      const colList: string[] = ['stName', 
      'staffName', 
      'aCount', 
      'tCount'];

      const dataList: string[] = [row.stName,
      row.staffName,
      row.aCount,
      row.tCount
    ];

      return AriaDirective.concatAriaStrings(colList, dataList) + (row.StudentTeamAttendanceDetails.length > 0 ? ' Expand for more details' : ' No additional details');
  }
}